<script>
import { mapActions, mapState } from 'vuex'

export default {
  async created () {
    await this.reload()
    this.cancela()
  },
  data () {
    return {
      filtros: {},
      titulo: '',
      form: {
      }
    }
  },
  computed: {
    ...mapState({
      all: state => state.tag.all,
      list: state => state.tag.list,
      page: state => state.tag.filtros.page,
      lastPage: state => state.tag.lastPage
    }),
    paginate () {
      let result = {
        dots_prev: false,
        firstPage: 1,
        page: parseInt(this.page),
        list: [],
        lastPage: parseInt(this.lastPage),
        dots_next: false
      }
      // Cria lista que ira exibir
      let comeca = -2
      let termina = 2
      if (result.page === result.firstPage) {
        comeca = 0
        termina = 4
      } else if (result.page - 1 === result.firstPage) {
        comeca = -1
        termina = 3
      } else if (result.page + 1 === result.lastPage) {
        comeca = -3
        termina = 1
      } else if (result.page === result.lastPage) {
        comeca = -4
        termina = 0
      }
      for (let x = comeca; x <= termina; x++) {
        let p = result.page + x
        if (p >= result.firstPage && p <= result.lastPage) result.list.push(p)
      }
      // Pega primeiro e ultimo item da lista
      let primeiroItem = result.list[0]
      // Valida Prev Next e Dots
      if (primeiroItem > result.firstPage) result.dots_prev = true
      if (result.page !== result.lastPage) result.next = true
      return result
    }
  },
  methods: {
    ...mapActions({
      add: 'tag/add',
      remove: 'tag/remove',
      change: 'tag/edit',
      get: 'tag/get',
      getAll: 'tag/all',
      getList: 'tag/list'
    }),
    async reload () {
      await this.getAll()
      await this.getList(this.filtros)
    },
    goToPage (page) {
      this.filtros.page = page
      this.getList(this.filtros)
    },
    async edita (item) {
      let form = await this.get(item.id)
      this.titulo = `Edita Tag - ${form.nome}`
      if (!form.tag_id) form.tag_id = ''
      let { id, nome } = form
      this.form = { id, nome, tag_id: form.tag_id }
    },
    async exclui (item) {
      if (confirm('Deseja mesmo excluir essa tag?')) {
        try {
          await this.remove(item.id)
          await this.reload()
        } catch (e) {
          if (e.response) {
            alert(e.response.data.message)
          } else alert(e.message)
        }
      }
    },
    async salva () {
      if (this.form.tag_id === '') {
        this.form.tag_id = null
      }
      try {
        if (!this.form.id) await this.add(this.form)
        else await this.change(this.form)
        await this.reload()
        this.cancela()
      } catch (e) {
        if (e.response) {
          alert(e.response.data.message)
        } else alert(e.message)
      }
    },
    cancela () {
      this.titulo = 'Nova Tag'
      this.form = {
        tag_id: ''
      }
    }
  }

}
</script>

<template>
  <div class="crud">
    <div class="columns">
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>Todas as tags</h4>
            <form @submit.prevent="getList(filtros)">
              <div class="field is-horizontal filtros">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input class="input" type="text" placeholder="Digite o nome" v-model="filtros.nome">
                    </p>
                  </div>
                  <div class="field">
                    <div class="control is-expanded">
                      <div class="select">
                        <select v-model="filtros.tag_id">
                          <option required value="">Selecione uma tag</option>
                          <option v-for="(option, indice) in all" :value="option.id" :key="indice">
                            {{ option.nome }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="field is-grouped">
                    <div class="control is-expanded">
                      <button class="button is-link is-info" type="submit"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <table class="table is-bordered is-narrow is-fullwidth mt-10">
              <thead>
                <tr>
                  <th><abbr title="Codigo">#</abbr></th>
                  <th>Nome</th>
                  <th>Tag Pai</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, indice) in list" :key="indice">
                  <td>{{ item.id }}</td>
                  <td>{{ item.nome }}</td>
                  <td>{{ item.tag ? item.tag.nome : '-' }}</td>
                  <td class="actions">
                    <button class="button is-small is-warning" @click="edita(item)"><i class="fa fa-pencil-alt"></i></button>
                    <button class="button is-small is-danger" @click="exclui(item)"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav class="pagination">
              <ul class="pagination-list">
                <li v-if="paginate.dots_prev"><a class="pagination-link" @click="goToPage(paginate.firstPage)">{{ paginate.firstPage }}</a></li>
                <li v-if="paginate.dots_prev"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-for="(item, indice) in paginate.list" :key="indice">
                  <a class="pagination-link" @click="goToPage(item)" :class="{ 'is-current': item === paginate.page }">{{ item }}</a>
                </li>
                <li v-if="paginate.dots_next"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-if="paginate.dots_next"><a class="pagination-link" @click="goToPage(paginate.lastPage)">{{ paginate.lastPage }}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>{{ titulo }}</h4>
            <form @submit.prevent="salva">
              <div class="field">
                <label class="label">Nome</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Digite o nome da tag" v-model="form.nome">
                </div>
              </div>
              <div class="control">
                <div class="select">
                  <select v-model="form.tag_id" >
                    <option required value="">Selecione uma tag</option>
                    <option v-for="(option, indice) in all" :value="option.id" :key="indice">
                      {{ option.nome }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field is-grouped mt-10">
                <div class="control">
                  <button class="button is-link is-success" type="submit">Salvar</button>
                </div>
                <div class="control">
                  <button class="button is-text" type="button" @click="cancela">Cancelar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .mt-10 {
    margin-top: 10px;
  }
  .crud {
    width: 100%;
    text-align: left;
    margin:10px;
  }
  .crud .table {
    margin: 0px;
    margin-top: 15px;
  }
  .crud .table tr {
    height: 30px;
  }
  .crud .table thead th {
    font-weight: bold;
  }
  .crud .table thead th, .crud .table tbody td {
    padding: 5px !important;
  }
  .crud .table tbody td.actions {
    text-align: center
  }
  .crud .table tbody td.actions button {
    margin-right: 5px;
  }
  .pagination .pagination-list {
    margin: 0px
  }
  .pagination .pagination-list li {
    list-style: none;
  }
  .control input, .control select {
    border: 1px solid #dbdbdb;
  }
</style>
